import React from 'react'

import { SecretaryFavorites } from 'presentation/secretary/pages/Favorites'

export default function makeHospitalFavoritesFactory() {
  return <SecretaryFavorites />
}
